import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextButtonExternalAtomSharedComponent } from './text-button-external.component';
import { IconSharedModule } from '../icon/entry';

@NgModule({
    declarations: [
        TextButtonExternalAtomSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        TextButtonExternalAtomSharedComponent
    ]
})

export class TextButtonExternalAtomSharedModule {}
